export enum DynamicPriceRulesFieldType {
    Number = 'number',
    String = 'string',
    Boolean = 'boolean',
    Date = 'date',
    Time = 'time',
    Select = 'select',
    // Free-text values matched against a list (v2 groups only, e.g. boat type).
    MultiSelect = 'multiselect'

    // Season = 'season',
    // TenantRelation = 'tenantRelation',
}
